import { HistoryOutlined } from "@ant-design/icons";
import { Empty, Space, Table, Tag } from "antd";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { useIngredient } from "./IngredientContext.tsx";
import { RecipeTab } from "../recipe/constants.ts";
import { routes } from "../../routes.ts";
import type { IngredientFragment } from "../../gql/generated/graphqlSchema.tsx";

type UsedInRecipe = IngredientFragment["usedInRecipes"][number];

export const IngredientUsedInRecipesTab = () => {
  const { t } = useTranslation();
  const { ingredient } = useIngredient();
  const rows = ingredient.usedInRecipes;

  return (
    <Table<UsedInRecipe>
      columns={[
        {
          title: t("recipes.name"),
          key: "name",
          render: (_, row) => (
            <Space>
              <Link to={{ pathname: routes.recipeDetail.to(row.recipe.id), hash: RecipeTab.Ingredients }}>
                {row.recipe.name}
              </Link>
              {row.isOutdated ? (
                <Tag color="warning" icon={<HistoryOutlined />}>
                  {t("ingredients.parentOutdated")}
                </Tag>
              ) : null}
            </Space>
          ),
        },
      ]}
      dataSource={rows}
      locale={{ emptyText: <Empty description={t("ingredients.usedInRecipesEmpty")} /> }}
      pagination={false}
      rowKey={(row) => row.recipe.id}
      size="small"
    />
  );
};
